<template>
    <v-sheet
             @mouseover="mouseover = true"
             @mouseout="mouseover = false"
             :elevation="hover && mouseover ? 2 : 12"
             class="mx-auto rounded-lg">
        <v-subheader class="d-flex justify-center">Price</v-subheader>
        <v-skeleton-loader loading v-if="false"
                           class="mx-auto"
                           max-width="300"
                           max-height="300"
                           type="card"></v-skeleton-loader>
        <v-card elevation="0">
            <v-form v-if="true">
                <v-card-text>
                    <div class="d-flex align-center"><span class="mr-4">Current Price:</span>
                        <div v-if="price && price.NEAR" class="d-flex align-center">
                            <icon-base height="20" width="20" viewBox="0 0 180 225" icon-name="near">
                                <icon-near iconColor="rgba(0, 0, 0, 1)" />
                            </icon-base><span class="text-body-1">{{ price.NEAR | formatNearAmount }}</span>,
                            <v-icon color="black" small class="ml-2">{{ mdiCurrencyUsd }}</v-icon><span class="text-body-1">{{ conversions.usd }}</span>
                        </div>
                        <div v-else class="text-uppercase">
                            Not currently for sale.
                        </div>
                    </div>
                    <v-row class="my-2">
                        <v-col cols="12" class="d-flex flex-wrap align-center">
                            <v-select id="currency" class="text-uppercase currency-select" v-model="select" :items="currencies" item-text="name" item-value="value" hide-details="false" :append-icon="mdiChevronDown" style="max-width: 40%" dense filled flat
                                      @change="convertCurrency()">
                                <template v-if="select === 'NEAR'" v-slot:prepend-inner>
                                    <icon-base height="25" width="25" viewBox="0 0 180 225" icon-name="near" class="d-flex align-center">
                                        <icon-near iconColor="rgba(0, 0, 0, 1)" />
                                    </icon-base>
                                </template>
                                <template v-else v-slot:prepend-inner>
                                    <v-icon>{{ mdiCurrencyUsd }}</v-icon>
                                </template>
                            </v-select>
                            <v-text-field :rules="rules.price" id="price" hide-details="auto" outlined class="mx-2" style="max-width: 50%" :label="`Price in ${select}`" hint="" dense v-model="priceConversion[select]"
                                          @input="convertCurrency()">
                                <template v-if="select === 'NEAR'" v-slot:append>
                                    <v-icon x-small>{{ mdiCurrencyUsd }}</v-icon>
                                    <span style="font-size: smaller">{{ priceConversion.USD }}</span>
                                </template>
                                <template v-else-if="select === 'USD'" v-slot:append>
                                    <icon-base height="15" width="15" viewBox="0 0 180 225" icon-name="near" class="d-flex align-center">
                                        <icon-near iconColor="rgba(0, 0, 0, 1)" />
                                    </icon-base>
                                    <span style="font-size: smaller">{{ priceConversion.NEAR }}</span>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-spacer></v-spacer>
                    </v-row>
                </v-card-text>
                <v-card-actions class="d-flex justify-center">
                    <v-btn @click="buttonHandler" class="mb-2" text>Update Price</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-sheet>
</template>
<style scoped>
</style>
<script>
import IconNear from "../components/IconNear.vue";
import IconBase from "../components/IconBase.vue";
import { mdiChevronDown, mdiCurrencyUsd } from "@mdi/js";
import { utils } from "near-api-js";

export default {
    name: "TsNftWidgetPrice",
    components: {
        IconBase,
        IconNear,
    },
    methods: {
        async convertCurrency() {
            if (this.select === "NEAR" && this.listing) {
                if (isNaN(this.priceConversion.NEAR)) return;
                this.$set(
                    this.price,
                    "USD",
                    Number.parseFloat(
                        this.priceConversion.NEAR * this.listing.averageUSD
                    ).toFixed(2)
                );
            } else if (this.select === "USD" && this.listing) {
                if (isNaN(this.priceConversion.USD)) return;
                this.$set(
                    this.price,
                    "NEAR",
                    Number.parseFloat(
                        this.priceConversion.USD * (1 / this.listing.averageUSD)
                    ).toFixed(2)
                );
            }
        },
        async buttonHandler() {
            const self = this;
            self.progress = true;
            try {
                await this.$near.updatePrice(
                    this.nft.indexer.token_new_owner_account_id,
                    this.nft.token_id,
                    this.priceConversion["NEAR"]
                );
                self.progress = false;
            } catch (error) {
                self.progress = false;
                console.log(error);
            }
        },
    },
    props: {
        hover: Boolean,
        nftComponent: Object,
    },
    model: {
        event: "change",
    },
    data: function () {
        return {
            mouseover: false,
            mdiChevronDown,
            mdiCurrencyUsd,
            priceConversion: {
                NEAR: null,
                USD: null,
            },
            listing: null,
            select: "NEAR",
            currencies: [
                { name: "near", value: "NEAR" },
                { name: "usd", value: "USD" },
            ],
            rules: {
                price: [
                    (v) => !!v || `Sure?!`,
                    (v) => !isNaN(Number.parseFloat(v)) || "Must be a number.",
                ],
            },
            blockchain: null,
            progress: false,
        };
    },
    watch: {
        async nft(value) {
            if (value && value.token_id) {
                this.blockchain = await this.$near.getNftMetadata(
                    value.token_id
                );
            }
        },
    },
    computed: {
        price() {
            return this.nft && this.nft.metadata && this.nft.metadata.sale_conditions ? { NEAR: this.nft.metadata.sale_conditions.sale_price } : undefined;
        },
        conversions() {
            const USD =
                this.listing
                    ? this.listing.averageUSD
                    : undefined;
            if (!this.price || !this.price.NEAR || !USD) return {};
            return {
                usd: Number.parseFloat(
                    utils.format.formatNearAmount(this.price.NEAR) *
                        this.listing.averageUSD
                ).toFixed(0),
            };
        },
        nft() {
            return this.nftComponent ? { ...this.nftComponent.nft, ...this.nftComponent } : undefined;
        },
    },
    mounted() {
        const self = this;
        (async function () {
            self.listing = await self.$backend.getLatestNearListing();
        })();
    },
};
</script>
